export const getIsPackageDeepLinking = state => state.deepLinking.package;
export const getIsCreateFormDeepLinking = state => state.deepLinking.createForm;
